export default __webpack_public_path__ + "static/media/first_aid.848914ac.svg";